import type { App, AppConfig } from 'vue'

let root: AppConfig['globalProperties']
let app: App

export function useInstance(App: App) {
  app = App
  root = app.config.globalProperties
}
export function getRoot() {
  return root
}

export function getApp() {
  return app
}
